const typography = {
  fontFamily: 'Plus Jakarta Sans, sans-serif',
  xlarge_3: {
    fontSize: '2.75rem',
    fontWeight: 700,
    lineHeight: '120%',
  },
  xlarge_2: {
    fontSize: '2.5rem',
    fontWeight: 700,
    lineHeight: '140%',
  },
  xlarge_1: {
    fontSize: '2.25rem',
    fontWeight: 700,
    lineHeight: '140%',
  },
  large_3: {
    fontSize: '2rem',
    fontWeight: 700,
    lineHeight: '140%',
  },
  large_2: {
    fontSize: '1.75rem',
    fontWeight: 600,
    lineHeight: '140%',
  },
  large_1: {
    fontSize: '1.5rem',
    fontWeight: 600,
    lineHeight: '140%',
  },
  medium_3: {
    fontSize: '1.375rem',
    fontWeight: 600,
    lineHeight: '140%',
  },
  medium_2: {
    fontSize: '1.25rem',
    fontWeight: 500,
    lineHeight: '140%',
  },
  medium_1: {
    fontSize: '1.125rem',
    fontWeight: 500,
    lineHeight: '140%',
  },
  small_3: {
    fontSize: '1rem',
    fontWeight: 400,
    lineHeight: '140%',
  },
  small_2: {
    fontSize: '0.875rem',
    fontWeight: 400,
    lineHeight: '140%',
  },
  small_1: {
    fontSize: 12,
    fontWeight: 600,
    lineHeight: '140%',
  },
  xsmall_3: {
    fontSize: '0.625rem',
    fontWeight: 400,
    lineHeight: '140%',
  },
  title_1: {
    fontSize: '4rem',
    fontWeight: 700,
    textAlign: 'center',
    lineHeight: 'normal',
  },
  title_2: {
    fontSize: '3rem',
    fontWeight: 600,
    lineHeight: '120%',
  },
  info_stack: {
    fontSize: '0.875rem',
    fontWeight: 800,
    lineHeight: '150%',
    letterSpacing: '0.0625rem',
  },
  info_stack_3: {
    fontSize: '1.375rem',
    fontWeight: 700,
    lineHeight: '180%',
  },
  body2: {
    fontSize: 14.4,
    '@media (max-width:600px)': {
      fontSize: 9.6,
    },
  },
  subtitle1: {
    fontWeight: 900,
    fontSize: 19.2,
    '@media (max-width:600px)': {
      fontSize: 12.8,
    },
  },
  subtitle2: {
    fontSize: 16,
    '@media (max-width:600px)': {
      fontSize: 11.2,
    },
  },
  h3: {
    fontWeight: 'bolder',
    fontSize: 24,
    '@media (max-width:600px)': {
      fontSize: 12.8,
    },
  },
};

export default typography;
